import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid } from '@material-ui/core';
import { useStyles } from './styles';
import { SynchronizationBlocks } from 'components/SynchronizationBlocks';

const Import: FC = observer(() => {
  const classes = useStyles();

  useEffect(() => {
    document.title = 'EasyIdentity: Import';
  }, []);

  return (
    <Container maxWidth='xl' className={classes.container}>
      <Grid className={classes.infoContainer} container alignItems='stretch' justify='space-between' spacing={3}>
        <SynchronizationBlocks />
      </Grid>
    </Container>
  );
});

export default Import;
